class popupVideo {
  constructor() {
    this.handleEscape = this.handleEscape.bind(this);

    this.boundImages = new Set();
    this.activePopup = null;
    this.activeTrigger = null;

    this.bindTriggers();
  }

  bindTriggers() {
    let triggers = document.querySelectorAll(".lc-popup-video__container");

    // Backward-compatible fallback for markup that does not yet include
    // the dedicated popup video trigger container.
    if (!triggers.length) {
      triggers = document.querySelectorAll(".lc-infobox-popup__col--video");
    }

    triggers.forEach(trigger => {
      if (this.boundImages.has(trigger)) {
        return;
      }

      const popup = this.getPopupForImage(trigger);

      if (!popup) {
        return;
      }

      this.initializePopup(popup);
      this.boundImages.add(trigger);
      trigger.style.cursor = "pointer";

      trigger.addEventListener("click", () => {
        this.openPopup(popup, trigger);
      });
    });
  }

  getPopupForImage(trigger) {
    const popupSection = trigger.closest(".lc-box-popup-main-container");

    if (!popupSection) {
      return null;
    }

    return popupSection.querySelector(".lc-popupvideo");
  }

  initializePopup(popup) {
    if (popup.dataset.popupVideoReady === "true") {
      return;
    }

    const contentNodes = Array.from(popup.childNodes);
    const background = document.createElement("div");
    const container = document.createElement("div");
    const inner = document.createElement("div");
    const head = document.createElement("div");
    const closeButton = document.createElement("a");
    const content = document.createElement("div");
    const footer = document.createElement("div");

    popup.textContent = "";
    popup.classList.add("iz-notes");
    popup.classList.add("iz-notes--popupvideo");
    popup.hidden = true;

    background.className = "iz-notes__background";
    container.className = "iz-notes__container";
    inner.className = "iz-notes__inner";
    content.className = "iz-notes__content--popupvideo";

    closeButton.className = "iz-notes__close lc-button--round";
    closeButton.setAttribute("href", "#");
    closeButton.setAttribute("aria-label", "Close popup");
    closeButton.innerHTML = `
      <span class="lc-button__inner">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
          <mask id="mask0_popupvideo_close" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
            <rect width="40" height="40" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_popupvideo_close)">
            <path d="M10.5794 30.4252L9.5752 29.421L18.9961 20L9.5752 10.579L10.5794 9.5748L20.0004 18.9957L29.4214 9.5748L30.4256 10.579L21.0047 20L30.4256 29.421L29.4214 30.4252L20.0004 21.0043L10.5794 30.4252Z" fill="#007DB2"/>
          </g>
        </svg>
      </span>
    `;

    contentNodes.forEach(node => {
      content.appendChild(node);
    });

    head.appendChild(closeButton);
    inner.appendChild(head);
    inner.appendChild(content);
    inner.appendChild(footer);
    container.appendChild(inner);
    popup.appendChild(background);
    popup.appendChild(container);

    background.addEventListener("click", () => this.closePopup());
    closeButton.addEventListener("click", event => {
      event.preventDefault();
      this.closePopup();
    });

    popup.dataset.popupVideoReady = "true";
  }

  openPopup(popup, trigger) {
    if (this.activePopup && this.activePopup !== popup) {
      this.closePopup();
    }

    popup.hidden = false;
    popup.classList.add("active");
    this.activePopup = popup;
    this.activeTrigger = trigger;

    document.addEventListener("keydown", this.handleEscape);

    const closeButton = popup.querySelector(".iz-notes__close");
    if (closeButton) {
      closeButton.focus();
    }
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.closePopup();
    }
  }

  closePopup() {
    if (!this.activePopup) {
      return;
    }

    if (this.activeTrigger) {
      this.activeTrigger.focus();
    }

    this.activePopup.classList.remove("active");
    this.activePopup.hidden = true;
    this.activePopup = null;
    this.activeTrigger = null;

    document.removeEventListener("keydown", this.handleEscape);

  }

}
export default popupVideo;
